import { LineChartProps } from '@mui/x-charts/LineChart';

/**
 * Average character width in pixels for Y-axis label calculations
 * This approximates the space needed per character in typical chart fonts
 */
const CHART_CHAR_WIDTH = 10;

export const calculateYAxisWidth = (
  seriesData: LineChartProps['series'],
  valueFormatter?: (value: any, context?: any) => string,
  charWidth = CHART_CHAR_WIDTH,
): number => {
  if (!seriesData) {
    return 0;
  }

  let maxLabelLength = 0;
  let hasValues = false;

  seriesData.forEach((series) => {
    if (Array.isArray(series.data)) {
      series.data.forEach((val, dataIndex) => {
        if (val !== null && val !== undefined) {
          hasValues = true;
          let formattedValue: string;
          if (valueFormatter) {
            formattedValue = valueFormatter(val, { dataIndex });
          } else {
            formattedValue = String(val);
          }
          maxLabelLength = Math.max(maxLabelLength, formattedValue.length);
        }
      });
    }
  });

  if (!hasValues) {
    return 0;
  }

  const calculatedWidth = maxLabelLength * charWidth;

  return calculatedWidth;
};
